// 砂拉越州球场数据
// Sarawak Golf Courses

export const SARAWAK_COURSES = {
  "BINTULU_GOLF_CLUB": {
    shortName: "BGC",
    fullName: "Bintulu Golf Club",
    location: ["Bintulu", "Sarawak", "Malaysia"],
    pars: [5,4,3,4,4,4,3,4,5, 4,3,4,4,4,5,3,4,5],
    index: [11,1,15,5,13,9,17,7,3, 12,18,14,6,16,10,8,2,4]
  },

  "BORNEO_GOLF&_COUNTRY_CLUB": {
    shortName: "BGCC",
    fullName: "Borneo Golf & Country Club",
    location: ["Kuching", "Sarawak", "Malaysia"],
    pars: [4,4,5,4,3,5,4,3,4, 4,5,4,4,3,4,3,5,4],
    index: [13,3,11,5,17,1,7,15,9, 12,4,16,2,8,10,18,6,14]
  },

  "DAMAI_GOLF_AND_COUNTRY_CLUB": {
    shortName: "DGCC",
    fullName: "Damai Golf And Country Club",
    location: ["Kuching", "Sarawak", "Malaysia"],
    pars: [5,4,3,4,4,3,4,5,4, 4,5,4,4,3,4,4,3,5],
    index: [15,5,3,1,13,9,7,17,11, 6,12,16,10,2,18,8,4,14]
  },

  "KELAB_GOLF_MIRI": {
    shortName: "KGM",
    fullName: "Kelab Golf Miri",
    location: ["Miri", "Sarawak", "Malaysia"],
    pars: [3,4,4,4,4,5,4,5,3, 4,4,3,4,4,4,3,5,5],
    index: [13,3,11,9,5,1,7,17,15, 2,4,14,8,10,6,12,18,16]
  },

  "KELAB_GOLF_SARAWAK_MATANG_SANTUBONG": {
    shortName: "KGS-MS",
    fullName: "Kelab Golf Sarawak (Matang/Santubong Course)",
    location: ["Kuching", "Sarawak", "Malaysia"],
    pars: [4,4,3,4,5,4,4,3,5, 4,4,4,5,3,5,4,3,4],
    index: [11,7,15,1,3,9,13,17,5, 12,8,16,10,18,4,2,14,6]
  },

  "KELAB_GOLF_SARAWAK_SIOL_DEMAK": {
    shortName: "KGS-SD",
    fullName: "Kelab Golf Sarawak (Siol/Demak Course)",
    location: ["Kuching", "Sarawak", "Malaysia"],
    pars: [5,4,4,3,4,3,5,4,4, 5,4,4,4,3,4,5,3,4],
    index: [7,11,13,17,3,15,1,9,5, 14,6,12,2,18,10,4,16,8]
  },

  "KELAB_GOLF_SIBU": {
    shortName: "KGS",
    fullName: "Kelab Golf Sibu",
    location: ["Sibu", "Sarawak", "Malaysia"],
    pars: [4,5,3,4,5,5,3,3,4, 4,4,5,3,3,4,4,3,4],
    index: [14,2,10,12,6,4,18,16,8, 1,9,3,15,17,11,7,13,5]
  },

  "SAMARAHAN_COUNTRY_CLUB": {
    shortName: "SCC",
    fullName: "Samarahan Country Club",
    location: ["Kota Samarahan", "Sarawak", "Malaysia"],
    pars: [4,4,3,5,3,4,4,5,4, 4,4,4,4,5,3,4,3,5],
    index: [12,4,16,2,10,18,14,6,8, 3,13,17,1,5,11,9,15,7]
  }
};

export default SARAWAK_COURSES;
